import axios from 'axios';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/lib/function';
import * as i from 'io-ts';
import * as Hooks from 'preact/hooks';
import * as ProductDataStore from '../../store/productData';
import * as Selectors from '../../store/selectors';
import { useDispatch, useSelector } from './redux';
import * as Product from '../../data/product';
import * as Gift from '../../data/gift/product';
import { AppError } from '../../data/appError';
import * as CoreStore from '../../store/core';

export const useLoadProductData = () => {
    const dispatch = useDispatch();
    const tenantIdentifier = useSelector(Selectors.Core.tenantIdentifier);
    const productDataUrl = useSelector(Selectors.Core.productDataUrl);

    Hooks.useEffect(() => {
        if (productDataUrl !== undefined && tenantIdentifier !== undefined) {
            axios
                .get(`${productDataUrl}/api/v1/${tenantIdentifier}/products`, {
                    responseType: 'json',
                })
                .then(result => {
                    const productData = pipe(
                        result.data,
                        i.array(Gift.Product).decode,
                        E.getOrElse((e): Gift.Product[] => {
                            dispatch(CoreStore.error(AppError.PRODUCT_DATA_FAILED));
                            throw e;
                        }),
                    );
                    const products = productData.map(Product.fromGiftProduct);
                    dispatch(
                        ProductDataStore.setProductData({
                            products,
                            bundles: productData.flatMap(bundleToDora),
                        }),
                    );
                });
        }
    }, [productDataUrl, tenantIdentifier]);
};

export function bundleToDora(product: Gift.Product): Array<ProductDataStore.Bundle> {
    return product.kind === 'bundle'
        ? [
              {
                  canonicalId: product.canonicalId,
                  productIds: product.products,
                  price: product.price.value,
                  ranges: product.properties['range'] ? product.properties['range'] : [],
                  discontinued: product.discontinued,
              },
          ]
        : [];
}
